module.exports = __webpack_public_path__ + "static/media/align-justify.87677f6a.svg";